// extracted by mini-css-extract-plugin
export var buttonsGroup = "index-module--buttonsGroup--tnDNB";
export var contentContainer = "index-module--contentContainer--sFRMI";
export var contentContainerMb = "index-module--contentContainerMb--28pZs";
export var en_title = "index-module--en_title--yol1M";
export var list = "index-module--list--QdJWV";
export var listItem = "index-module--listItem--DThRA";
export var swiperStyle = "index-module--swiperStyle--gQUUt";
export var title = "index-module--title--WpJa9";